package com.fireavert.events.deleteeventfromhistory

@kotlinx.serialization.Serializable
data class DeleteFromEventHistoryResponse(
    val success: Boolean? = null
)
